import _ from 'lodash'

export const dataFormatter = (jobs = []) => {
  const response = []
  for (let item of jobs){
    if (item && !_.isEmpty(item) && _.isObjectLike(item)){
      if (!_.get(item, 'workflows')) {
        item.workflows = []
      }
      let parsedItem = {
            id: item.job_id,
            account_id: item.account_id,
            account_name: item.account_name || '----',
            clip_duration: item.clip_duration || '----',
            end_time: item.end_time,
            job_id: item.job_id,
            job_type: item.job_type,
            media_id: item.media_id,
            progress: item.progress,
            start_time: item.start_time,
            status: item.status,
            total_time: item.total_time || '----',
            zone: item.zone,
            workflow: 'Details'
      }
      response.push(parsedItem)
    }
  }
  return response
}


// WEBPACK FOOTER //
// ./src/utils/index.js